<template>
    <div v-if="isPc">
      <el-row :gutter=20 type="flex" justify="center" >
          <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9">
            <div class="text-center">
                <h2 class="font-20"><strong>物料逐支跟踪系统</strong></h2>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9">
            <div class="text-center">
                <h2 class="font-20"><strong>智能化集控中心</strong></h2>
            </div>
          </el-col>
      </el-row>
      <el-row :gutter=20 type="flex" justify="center" >
        <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9">
          <div  class=" divimage div-tab-image1 " @mouseenter="mouseenterTrack" @mouseleave="mouseleaveTrack" style="height:462px;" ><div >
              <div  v-show="isShow" class="service-content animated fadeInUp " >
                <div class="flex-box-center" style="height:100%;padding: 10px;">
                  <div style="height:45px"><h1 class="tab-title">物料逐支跟踪系统</h1></div>
                  <div style="height:210px" class="mt20"><h6 class="tab-desc">完美解决传统的只能以批号为单位进行生产跟踪问题，打通精整、库存存在明显的信息孤岛，在出现产品质量问题时快速精准定位，提升业务管控效率。</h6> </div>
                  <div class="btnbutton flex-box-center" @click="showTrack">
                    <span>查看详情</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
       </el-col>
       <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9">
          <div class="divimage div-tab-image2  "  @mouseenter="mouseenterControl" @mouseleave="mouseleaveControl" style="height:462px;">
              <div v-show="isShow2" class="service-content animated fadeInUp">
                <div class="flex-box-center" style="height:100%;padding: 10px;">
                  <div style="height:45px"><h1 class="tab-title">智能化集控中心</h1></div>
                  <div style="height:210px" class="mt20"><h6 class="tab-desc">建立集中一贯的智能化管控体系，打破部门分工界限，将制造全流程业务紧密集成，构建公司级“统一、高效、集中、专业”的平台，集“调度、管控、指挥、发布”于一体，实时展示制造管理的全貌。作为信息中枢，充分体现信息的及时性和准确性；负责生产运行的监控、协调和调整，充分体现制造管理的敏捷性；集控中心将作为最高指挥平台，是传统的钢铁制造模式的重大突破。</h6></div>
                  <!-- <el-button  round @click="showControl">了解详情</el-button> -->
                  <div class="btnbutton flex-box-center" @click="showControl">
                    <span>查看详情</span>
                  </div>
                </div>
              
            </div>
          </div>
       </el-col>
    </el-row>
  </div>
  <!-- 移动端适配 -->
  <div v-else>
    <el-row >
      <el-col :span="24">
        <div class="text-center">
          <h2 class="font-20"><strong>逐支跟踪系统</strong></h2>
        </div>
      </el-col>
      <div  class="divimage div-tab-image1 " style="height: 400px" @mouseenter="mouseenterTrack" @mouseleave="mouseleaveTrack" >
          <div  v-show="isShow"  class="service-content animated fadeInUp "   >
            <div class="flex-box-center" style="height:100%;padding: 10px;">
              <div style="height:35px"><h1 class="tab-title">逐支跟踪系统</h1></div>
              <div style="height:140px" class="mt20"><h6 class="tab-desc">完美解决传统的只能以批号为单位进行生产跟踪问题，打通精整、库存存在明显的信息孤岛，在出现产品质量问题时快速精准定位，提升业务管控效率。</h6> </div>
              <!-- <el-button  round @click="showTrack">了解详情</el-button> -->
              <div class="btnbutton flex-box-center" @click="showTrack">
                <span>查看详情</span>
              </div>
            </div>
          </div>
      </div>
    </el-row>

    <el-row >
      <el-col :span="24">
        <div class="text-center">
            <h2 class=" mt40 font-20"><strong>集控中心</strong></h2>
        </div>
      </el-col>
      <div class="divimage div-tab-image2 mt20" style="height: 400px"  @mouseenter="mouseenterControl" @mouseleave="mouseleaveControl">
          <div v-show="isShow2" class="service-content animated fadeInUp">
            <div class="flex-box-center" style="height:100%;padding: 10px;">
              <div style="height:35px"><h1 class="tab-title">集控中心</h1></div>
              <div style="height:250px" class="mt20"><h6 class="tab-desc">建立集中一贯的智能化管控体系，打破部门分工界限，将制造全流程业务紧密集成，构建公司级“统一、高效、集中、专业”的平台，集“调度、管控、指挥、发布”于一体，实时展示制造管理的全貌。作为信息中枢，充分体现信息的及时性和准确性；负责生产运行的监控、协调和调整，充分体现制造管理的敏捷性；集控中心将作为最高指挥平台，是传统的钢铁制造模式的重大突破。</h6></div>
              <!-- <el-button  round @click="showControl">了解详情</el-button> -->
                <div class="btnbutton flex-box-center" @click="showControl">
                    <span>查看详情</span>
                </div>
            </div>
          </div>
      </div>
    </el-row>
  </div>
</template>
<script>
import {mapState} from "vuex"
export default {
    name:"tabNews",
    data(){
        return{
          isShow:false,
          isShow2:false
       }
    },
    mounted(){
         
    },
    props:{

    },
    methods:{
      mouseenterTrack: function() {
        this.isShow = true;
      },
      mouseleaveTrack: function() {
        this.isShow = false;
      },

      mouseenterControl: function() {
        this.isShow2 = true;
      },
      mouseleaveControl: function() {
        this.isShow2 = false;
      },
      showTrack(){
        this.$router.push({
          path:"/ProductTrack",
        })
      },
      showControl(){
        this.$router.push({
          path:"/ProductControl",
        })
      }
    },
    computed:{
         ...mapState({tabList: 'TabList',isPc:'isPc'}) ,
        //  showNews(){
        //     return this.tabList.slice(0,2); 
        //  }
    }
}
</script>

<style>

.service-content {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #7391ed;
    display: block;
    top: 0;
    left: 0;
    /* transform: translate3d(0, 50%, 0); */
    /* opacity:0; */
    /* transition: all 0.5s; */
    /* text-decoration: none; */
    /* padding-top: 100px; */
}

.div-tab-Bg{
  position: absolute;
    width:100%;
    height: 100%;
    background: #ffffff;
 }

.div-tab-image1{
    width:100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size:cover;
    background-image: url("../assets/images/aboutTab/tabimage1.jpg");
    position: relative;
    /* display: table; */
    background-position:center center;
 }
 .div-tab-image2{
    width:100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size:cover;
    background-image: url("../assets/images/aboutTab/tabimage2.png");
    position: relative;
    /* display: table; */
    background-position:center center;
 }

 .tab-title{
  font-size:30px;
  font-weight:600;
  color:#ffffff;
  line-height:48px;
  text-align:center;
  margin-bottom:19px;
  }

 .tab-desc{
   font-size:16px;
  line-height:1.8em;
  display:block;
  font-weight:500;
  color:#ffffff;
  font-family:inherit;
  margin-top:20px;
  /* letter-spacing: 1px; */
  /* text-align: left; */
 }

 .buttondetail{
  position: absolute;
  top:300px;
  margin-left:80px;
}

.btnbutton{
  color:#fff;
  width:120px;
  height:40px;
  font-size:16px;
  border-radius:140px;
  border: 2px solid #fff;
}

 .btnbutton:hover   {
    cursor: pointer;
    background:rgba(255,255,255,0.2);
} 
</style>